import { AxiosResponse } from "axios";
import _ from "lodash";
import { IResponseResult } from "@/services/data/base_types";
import base_ds from "@/services/base_datasource_service";
import {CutHistoryType, CutType} from "@/services/models-service";
import request from "@/utils/request";


export const route_ns = `cut_history`;

class CutHistoryService {
    public current: CutHistoryType | null = null;
    public crud = base_ds.getBaseCrud(route_ns);
    public data_source = base_ds.getBaseDataSource(route_ns);

    public setCurrent(value: CutHistoryType) {
      this.current = value;
    }

    public async getById(entity_id: string): Promise<IResponseResult<CutHistoryType>> {
      const response: AxiosResponse["data"] = await this.crud.get_by_id(entity_id);
      if (response) {
        return response;
      } else {
        return { data: null, message: "" };
      }
    }


  }

  export default new CutHistoryService();
